'use client';

import { useAccountInfo } from './account';
import { useAtomValue } from 'jotai';
import { visitorAtom } from '@/atoms/visitor';
import { ApiBackendInfo } from './athena/types';
import { useMemo } from 'react';

import { AccountActStatus } from '@nf/utils-common/constants';

export const useApiBackendInfo = () => {
	const { user } = useAccountInfo();
	const visitorInfo = useAtomValue(visitorAtom);
	return useMemo(() => {
		const url = user ? user.ApiBackendUrl : (visitorInfo?.ApiBackendUrl ?? '');
		const token = user ? (user.AccessToken ?? '') : (visitorInfo?.OneAccessToken ?? '');
		const apiBackendInfo: ApiBackendInfo = {
			url,
			token,
			isReady: url !== '' && token !== '',
			isBefore: !user,
			hasNoDeposit: user?.ActStatus === AccountActStatus.NotDeposit
		};
		return apiBackendInfo;
	}, [user?.AccessToken, user?.ApiBackendUrl, visitorInfo?.ApiBackendUrl, visitorInfo?.OneAccessToken])
}